class TransitionHelper {
  static isViewTransitionSupported() {
    return 'startViewTransition' in document;
  }

  static async executeTransition(callback) {
    if (!this.isViewTransitionSupported()) {
      
      await callback();
      return;
    }

    try {
      const transition = document.startViewTransition(async () => {
        await callback();
      });
      
      await transition.finished;
      
    } catch (error) {
      
      await callback();
    }
  }

  // Main method yang digunakan untuk semua navigasi
  static async fadeTransition(callback) {
    return this.executeTransition(callback);
  }

  // Legacy methods untuk backward compatibility
  static async slideTransition(callback, direction = 'left') {
    return this.fadeTransition(callback);
  }

  static async customPageTransition(callback, fromPage, toPage) {
    return this.fadeTransition(callback);
  }

  static setTransitionName(element, name) {
    if (element && this.isViewTransitionSupported()) {
      element.style.viewTransitionName = name;
    }
  }

  static clearTransitionName(element) {
    if (element && this.isViewTransitionSupported()) {
      element.style.viewTransitionName = '';
    }
  }
}

export default TransitionHelper;